import React from 'react'

export default function Dashboard() {
  return (
    <div><h2>Dashboard - My Action Items</h2></div>
  )
}
